import { postFn } from './postFn'

// ── notifyFollow ───────────────────────────────────────────────────────────────
// The inbox notice for a new follower is written by a database trigger the moment
// the follows row lands; this sends the PUSH for it (2026-10-10, Jason: "if we're
// not firing a notification to the other user we should"). Fire-and-forget: a
// follow must never fail or stall because a push did. The function itself proves
// the follow exists, honours the recipient's activity opt-out, and dedupes to one
// push per pair per 12 hours.
export function notifyFollow(targetId) {
  if (!targetId) return
  try { postFn('/.netlify/functions/notify-activity', { type: 'follow', extra: { to_user: targetId } }).catch(() => {}) } catch { /* offline, sandbox, or signed out */ }
}
